<template>
  <div class="responsible-lending">
    <ResponsibleLending />
  </div>
</template>

<script>
import ResponsibleLending from "@/components/public/pages/responsible-lending/ResponsibleLending";
export default {
  name: "LimeLoansResponsiblelendingpage",

  components: { ResponsibleLending },

  metaInfo: {
    meta: [
      {
        name: "facebook-domain-verification",
        content: process.env.VUE_APP_FACEBOOK_DOMAIN_VERIFICATION,
      },
    ],
  },

  data() {
    return {};
  },

  mounted() {},

  methods: {},
};
</script>

<style lang="scss" scoped>
//
</style>
